import { Link } from 'react-router-dom';

const mission = [
  {
    icon: 'ri-focus-3-line',
    title: 'Our Mission',
    description: 'To make professional security system installation accessible and affordable for every home and business — protecting what matters most with expert craftsmanship and honest service.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Our Vision',
    description: 'A future where every property is protected by a professionally installed, properly monitored security system — not just those who can afford a big corporate contract.',
  },
  {
    icon: 'ri-award-line',
    title: 'Our Expertise',
    description: '15+ years of security system installation experience, 500+ properties secured, and 60+ licensed technicians specializing in cameras, CCTV, alarm, and access control systems.',
  },
];

const timeline = [
  { year: '2009', event: 'Founded with a mission to professionalize security system installation' },
  { year: '2013', event: 'Expanded to commercial security — retail, restaurants, and office buildings' },
  { year: '2016', event: 'Launched smart home automation installation division' },
  { year: '2020', event: 'Reached 500+ successful security system installations nationwide' },
  { year: '2024', event: 'Expanded to 48 states with 60+ licensed technicians and same-day service' },
];

export default function MissionVision() {
  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-slate-100" />

      {/* Right image accent */}
      <div className="absolute right-0 top-0 bottom-0 w-2/5 hidden xl:block overflow-hidden opacity-30">
        <img
          src="https://public.readdy.ai/ai/img_res/9a8365ff396d88cd9e574972279e90f9.jpg"
          alt=""
          className="w-full h-full object-cover object-left"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/50 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full text-orange-700 text-xs font-bold uppercase tracking-[0.2em] border border-orange-200 bg-orange-50 mb-4">
            Who We Are
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            Mission, Vision &amp; Expertise
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Built by security professionals who believe every property deserves expert-installed protection.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-14">
          {mission.map((item, i) => (
            <div
              key={item.title}
              className={`rounded-2xl p-8 border cursor-default text-center ${
                i === 1
                  ? 'border-orange-200 bg-orange-50'
                  : 'border-slate-200 bg-white'
              }`}
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-orange-100 border border-orange-200 mx-auto mb-5">
                <i className={`${item.icon} text-orange-600 text-2xl`} />
              </div>
              <h3 className="font-display font-black text-slate-900 text-xl mb-3">{item.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {[
            { value: '15+', label: 'Years Experience', icon: 'ri-history-line' },
            { value: '500+', label: 'Installs Completed', icon: 'ri-camera-fill' },
            { value: '60+', label: 'Licensed Technicians', icon: 'ri-tools-fill' },
            { value: '4.9★', label: 'Average Rating', icon: 'ri-star-fill' },
          ].map((stat) => (
            <div key={stat.label} className="rounded-2xl border border-slate-200 bg-white p-6 text-center">
              <div className="w-9 h-9 flex items-center justify-center mx-auto mb-2">
                <i className={`${stat.icon} text-orange-500 text-xl`} />
              </div>
              <p className="text-slate-900 font-display font-black text-3xl">{stat.value}</p>
              <p className="text-slate-500 text-sm mt-1 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Timeline */}
        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-8 mb-10">
          <h3 className="font-display font-black text-slate-900 text-xl mb-7 text-center">Our Journey</h3>
          <div className="flex flex-col gap-0 max-w-lg mx-auto">
            {timeline.map((item, index) => (
              <div key={item.year} className="flex items-start gap-5 relative">
                <div className="flex flex-col items-center flex-shrink-0">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-100 border-2 border-orange-300 z-10">
                    <span className="text-orange-700 font-black text-xs">{item.year.slice(2)}</span>
                  </div>
                  {index < timeline.length - 1 && (
                    <div className="w-px flex-1 bg-gradient-to-b from-orange-200 to-transparent min-h-[32px]" />
                  )}
                </div>
                <div className="pb-6">
                  <p className="text-orange-600 font-bold text-sm mb-0.5">{item.year}</p>
                  <p className="text-slate-600 text-sm">{item.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <Link
            to="#contact"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-slate-900 text-white font-black text-sm hover:bg-slate-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Schedule Your Free Installation Consultation
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
